
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,

  SET_TOOLS: (state, payload) => state.tools = payload,
}